import axios from 'axios'

export default {
    get: () => axios.get('cedis'),
    store: (data) => axios.post('cedis/store', data),
    update: (data) => axios.post('cedis/update', data),
    delete: (id) => axios.post('cedis/delete', id)
}